'use strict';
import polyfill from "dynamic-polyfill/src";

export default function ready() {
    // we use window because this could be used by several separate bundles
    if (window._ready instanceof Promise) {
        return window._ready;
    }
    if (window._ready !== undefined) {
        throw new Error('Property window._ready is needed for application bootstrap but is used by another module.');
    }
    if (document.documentElement.classList.contains('js-off')) {
        // do not execute if js is off
        window._ready = Promise.reject();
    } else {
        window._ready = Promise.resolve()
            .then(cancelFallback)
            .then(loadPolyfills)
        ;
    }
    return window._ready;
}

function loadPolyfills() {
    return polyfill({
        fills: [
            'Array.prototype.find',
            'Array.prototype.forEach',
            'Array.prototype.map',
            'document.head',
            'document.querySelector',
            'Element.prototype.classList',
            'Element.prototype.closest',
            'Element.prototype.matches',
            'Element.prototype.remove',
            'Element.prototype.replaceWith',
            'Event',
            'innerWidth',
            'innerHeight',
            'IntersectionObserver',
            'JSON',
            'Map',
            'matchMedia',
            'MediaQueryList.prototype.addEventListener',
            'MutationObserver',
            'Node.prototype.contains',
            'NodeList.prototype.forEach',
            'requestAnimationFrame',
            // 'requestIdleCallback', // polyfilled locally because of Safari
            'Set',
            'URLSearchParams',
            'XMLHttpRequest',
        ],
        // options: ['gated', 'always'],
        // minify: true,
        // Real User Monitoring
        rum: true,
    }).catch(console.warn);
}

function cancelFallback() {
    // cancel fallback since script is loaded
    if (typeof window.fallback === 'object') {
        window.fallback.cancel();
    }
}